import * as React from "react";
import {AppBarSpacer} from "../Components/AppBarSpacer";
import {observer} from "mobx-react";
import {Divider, Drawer, useMediaQuery, useTheme} from "@mui/material";
import MenuList from "./MenuList";
import {UserAvatar} from "./UserAvatar";
import {drawerWidth} from "../../../config/layout";
import {useGlobalStores} from "../../../hooks/use_global_stores";
import {useLocation} from "react-router-dom";
import {AtlasMenuList} from "../../Atlas/AtlasMenuList";
import {Role} from "../../../config/roles";

interface ILeftSideBarProps {
    open: boolean;
    onClose(): void;
}

const LeftSideBarComponent = ({open, onClose}: ILeftSideBarProps) => {
    const { userStore, authStore } = useGlobalStores();
    const isLargeScreen = useMediaQuery(useTheme().breakpoints.up('lg'));
    const { pathname } = useLocation();

    const user = userStore.currentUser;
    const isAdmin = authStore.accessToken!.getRoles().indexOf(Role.ADMIN) > -1;

    return (
        <Drawer
            variant={!isLargeScreen ? "temporary" : "permanent"}
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDrawer-paper': {
                    position: 'relative',
                    whiteSpace: 'nowrap',
                    width: drawerWidth,
                    transition: (theme) => theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                },
            }}
        >
            {isLargeScreen && <AppBarSpacer />}

            {(isAdmin && !!pathname.match(/^\/atlas.*$/)) ?
                (
                    <AtlasMenuList onItemClick={onClose} />
                ) : (
                    <>
                        <UserAvatar user={user ? user.email[0] : 'EM'} />
                        <Divider />
                        <MenuList isAdmin={isAdmin} onItemClick={onClose} />
                    </>
                )
            }

        </Drawer>
    );
};

export const LeftSideBar = observer(LeftSideBarComponent);
